/**
 * Classifica um status de documento em uma das 3 categorias (semáforo)
 * Regular (verde) | Em Andamento (amarelo) | Irregular (vermelho)
 */
export function classifyDocumentStatus(status) {
    if (!status)
        return 'Irregular';
    const s = status.toLowerCase().trim();
    // REGULAR (verde): Isento, Permanente, Vigente, Vigente/Em renovação
    if (/^(isento|permanente|vigente)$/i.test(s)) {
        return 'Regular';
    }
    if (/^vigente\s*\/\s*em\s+(renovação|renovacao)$/i.test(s)) {
        return 'Regular';
    }
    // EM ANDAMENTO (amarelo): Em obtenção ou renovação ativa
    if (/em (obtenção|obtencao)|\/em (obtenção|obtencao)/.test(s)) {
        return 'Em Andamento';
    }
    if (/^vencido\s*\/\s*em\s+(renovação|renovacao)$/i.test(s)) {
        return 'Em Andamento';
    }
    if (/^inexistente\s*\/\s*em\s+(obtenção|obtencao)$/i.test(s)) {
        return 'Em Andamento';
    }
    // IRREGULAR (vermelho): Demais casos
    return 'Irregular';
}
/**
 * Normaliza string removendo acentos e convertendo para uppercase
 */
export function normalizeString(str) {
    if (!str)
        return '';
    return String(str)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase();
}
/**
 * Normaliza string para lowercase (comparações)
 */
export function normalizeStringLower(str) {
    if (!str)
        return '';
    return String(str)
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}
/**
 * Formata número no padrão brasileiro
 */
export function formatNumberBR(value, options = {}) {
    const { decimals = 0, prefix = '', suffix = '' } = options;
    const formatted = value.toLocaleString('pt-BR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
    return `${prefix}${formatted}${suffix}`;
}
/**
 * Formata CNPJ
 */
export function formatCNPJ(cnpj) {
    if (!cnpj)
        return '—';
    const cleaned = String(cnpj).replace(/\D/g, '');
    if (cleaned.length !== 14)
        return cnpj;
    return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}
/**
 * Extrai UF de CityStateName (formato "Cidade/UF")
 */
export function extractUF(cityStateName) {
    if (!cityStateName)
        return null;
    const parts = String(cityStateName).split('/');
    if (parts.length === 2) {
        return parts[1].trim().toUpperCase();
    }
    return null;
}
/**
 * Classifica uma unidade com base em seus documentos, aplicando regra "pior prevalece"
 * Se ANY documento é Irregular → Unidade = Irregular
 * Se ANY documento é Em Andamento → Unidade = Em Andamento
 * Senão → Unidade = Regular
 * Se não há documentos → sem_doc (tratado como irregular)
 */
export function classifyUnitByDocs(documentStatuses) {
    if (!documentStatuses || documentStatuses.length === 0) {
        return 'sem_doc';
    }
    const categories = documentStatuses.map(classifyDocumentStatus);
    // Regra "pior prevalece"
    if (categories.includes('Irregular')) {
        return 'irregular';
    }
    if (categories.includes('Em Andamento')) {
        return 'em_andamento';
    }
    return 'regular';
}
/**
 * Mapeia categoria de unidade para cor CSS
 */
export function getStatusColor(category) {
    const colorMap = {
        regular: 'var(--status-regular)',
        'Regular': 'var(--status-regular)',
        em_andamento: 'var(--status-andamento)',
        'Em Andamento': 'var(--status-andamento)',
        irregular: 'var(--status-irregular)',
        'Irregular': 'var(--status-irregular)',
        sem_doc: 'var(--status-irregular)',
    };
    return colorMap[category] || colorMap.irregular;
}
/**
 * Lista de regionais conhecidas
 */
export const REGIONALS = [
    'BA/SE',
    'CO',
    'MG',
    'NE',
    'NO',
    'PR/SC',
    'RJ/ES',
    'RS',
    'SP1',
    'SP2',
];
/**
 * Mapeamento de Regional para UFs
 */
export const REGIONAL_UFS = {
    'BA/SE': ['BA', 'SE'],
    'CO': ['DF', 'GO', 'MS', 'MT'],
    'MG': ['MG'],
    'NE': ['AL', 'CE', 'MA', 'PB', 'PE', 'PI', 'RN'],
    'NO': ['AC', 'AM', 'AP', 'PA', 'RO', 'RR', 'TO'],
    'PR/SC': ['PR', 'SC'],
    'RJ/ES': ['RJ', 'ES'],
    'RS': ['RS'],
    'SP1': ['SP'],
    'SP2': ['SP'],
};
/**
 * Todas as UFs do Brasil
 */
export const BRAZIL_UFS = [
    'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO',
    'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR',
    'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO',
];
//# sourceMappingURL=utils.js.map